import { useContext } from 'react';
import { UseToasterReturnedProps } from '@twilio-paste/core/toast';

import { ToastContext } from '../../providers/toastProvider';

function useToasterContext(): UseToasterReturnedProps {
  return useContext(ToastContext);
}

export default useToasterContext;
